<script setup lang="ts">
import Address from '~/components/search/Address.vue'
</script>

<template>
	<Address></Address>
</template>
